import { ActionType as AccessTokenActionType, Action as AccessTokenAction } from '~/AccessToken';
import { ProductPriceHistoryRecord } from '~/Api/Product/PriceHistory';

import ActionTypes from './ActionTypes';

export interface HistoryState {
	request: Promise<any>;
	isFetching: boolean;
	prices: ProductPriceHistoryRecord[];
}

export interface State {
	byProductIdAndCurrency: { [key: string]: HistoryState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			productId: string;
			currency: string | null;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			productId: string;
			currency: string | null;
			prices: ProductPriceHistoryRecord[] | null;
	  }
	| { type: ActionTypes.pruneAll };

function createState(): State {
	return {
		byProductIdAndCurrency: {},
	};
}

export default function reducer(state: State = createState(), action: Action | AccessTokenAction): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byProductIdAndCurrency: {
					...state.byProductIdAndCurrency,
					[`${action.productId}-${action.currency ?? ''}`]: {
						request: action.request,
						isFetching: true,
						prices: [],
					},
				},
			};

		case ActionTypes.receive: {
			const key = `${action.productId}-${action.currency ?? ''}`;
			if (state.byProductIdAndCurrency[key]?.request !== action.request) {
				return state;
			}
			if (!action.prices) {
				const byProductIdAndCurrency = { ...state.byProductIdAndCurrency };
				delete byProductIdAndCurrency[key];
				return { ...state, byProductIdAndCurrency };
			}

			return {
				...state,
				byProductIdAndCurrency: {
					...state.byProductIdAndCurrency,
					[key]: {
						...state.byProductIdAndCurrency[key],
						isFetching: false,
						prices: action.prices,
					},
				},
			};
		}

		case ActionTypes.pruneAll:
			return createState();

		case AccessTokenActionType.receive:
			return action.userChanged ? createState() : state;

		case AccessTokenActionType.receiveLogin:
			return createState();

		default:
			return state;
	}
}

export function selectPriceHistory(state: State, productId: string, currency: string | null): HistoryState {
	return state.byProductIdAndCurrency[`${productId}-${currency ?? ''}`];
}
